import { AlertCircle, History, Loader2 } from 'lucide-react';
import JournalVersions from '../components/JournalVersions';
import { useAuth } from '../hooks/useAuth';
import { VERSION } from '../version';

/**
 * La version de l'application et son journal, en page à part.
 *
 * Elle vivait en section des Paramètres ; elle relève en fait de
 * l'Administration — on vient y lire ce qui a changé, pas régler quoi que ce
 * soit.
 */
export default function VersionPage() {
  const { isLoading, aLeDroit } = useAuth();
  // Le journal n'ouvre sur rien qu'on puisse toucher : on vient y lire ce qui
  // a changé. Le réserver aux administrateurs privait le bureau de la seule
  // réponse à « pourquoi cet écran a-t-il changé ? », et faisait poser la
  // question à l'assistance. Il passe donc par la grille, comme le reste.
  const peutVoir = aLeDroit('voir_versions');

  if (isLoading) {
    return (
      <div className="p-8 flex justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary-600" />
      </div>
    );
  }

  if (!peutVoir) {
    return (
      <div className="p-4 lg:p-0 pb-24 lg:pb-0">
        <div className="card bg-red-50 border-red-200 text-red-800 flex items-start gap-3">
          <AlertCircle className="w-5 h-5 mt-0.5" />
          <div>
            <p className="font-semibold">Accès réservé</p>
            <p className="text-sm mt-1">
              Le journal des versions dépend de votre fonction au bureau : un administrateur peut
              l'ouvrir dans la grille de droits.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 lg:p-0 space-y-5 lg:space-y-6 pb-24 lg:pb-0">
      <div className="flex items-center gap-3">
        <History className="w-7 h-7 text-primary-700" />
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-gray-100">Version</h1>
          <p className="text-sm lg:text-base text-gray-600 dark:text-gray-400">
            Le site est en version {VERSION}. Le journal détaille ce que chaque livraison a
            changé, du plus récent au plus ancien.
          </p>
        </div>
      </div>

      <div className="card lg:p-6">
        <JournalVersions />
      </div>
    </div>
  );
}
